import { Component } from '@angular/core';
import { GenericButtonComponent } from '../generic-button/generic-button.component';

@Component({
  selector: 'app-delete-button',
  imports: [GenericButtonComponent],
  templateUrl: './delete-button.component.html',
  styleUrl: './delete-button.component.css',
})
export class DeleteButtonComponent extends GenericButtonComponent {
  constructor() {
    super();
    this.textContent = 'Slet';
    this.color = 'primary';
    this.keyListener = 'Delete';
  }
}
